import { BinLocation, LpuOrder, LpuSession, PackLine } from './types';

const bike = (
  gid: string,
  sku: string,
  title: string,
  upc: string,
  weightLbs: number,
  mpn: string | null = null,
  binLocations: BinLocation[] = [],
): PackLine => ({
  shopifyLineItemGid: gid,
  sku,
  title,
  imageUrl: null,
  weightLbs,
  upc,
  mpn,
  itemType: 'bike',
  binLocations,
});

const paa = (
  gid: string,
  sku: string,
  title: string,
  upc: string,
  weightLbs: number,
  mpn: string | null = null,
  binLocations: BinLocation[] = [],
): PackLine => ({
  shopifyLineItemGid: gid,
  sku,
  title,
  imageUrl: null,
  weightLbs,
  upc,
  mpn,
  itemType: 'paa',
  binLocations,
});

export const LPU_ORDERS: LpuOrder[] = [
  {
    shopifyOrderId: 9001,
    shopifyOrderName: '#TPC-9001',
    shopifyOrderGid: 'gid://shopify/Order/9001',
    createdAt: '2026-04-20T09:00:00Z',
    stagedAt: null,
    lifecycleStatus: 'picked',
    customer: { firstName: 'Elena', lastName: 'Martinez', email: 'emartinez@example.com' },
    lines: [
      bike(
        'gid://shopify/LineItem/90011',
        'BIK-TREK-MADONE-SL5-54-BLK',
        'Trek Madone SL 5 — 54cm / Matte Black',
        '060115863001',
        18.5,
        'MADONE-SL5-54-BLK-2023',
        [
          {
            id: 301,
            binCode: 'BIKE-A12',
            quantity: 1,
            zone: 'Bike Floor',
            parentZone: null,
            locationType: 'pick',
          },
        ],
      ),
    ],
  },
  {
    shopifyOrderId: 9002,
    shopifyOrderName: '#TPC-9002',
    shopifyOrderGid: 'gid://shopify/Order/9002',
    createdAt: '2026-04-20T10:15:00Z',
    stagedAt: null,
    lifecycleStatus: 'picked',
    customer: { firstName: 'Ben', lastName: 'Nakamura', email: 'bnakamura@example.com' },
    lines: [
      paa(
        'gid://shopify/LineItem/90021',
        'PAA-HELMET-S-BLK',
        'Giro Cinder MIPS Helmet — S / Black',
        '012345678901',
        0.8,
        'CINDER-MIPS-S-BLK',
        [
          {
            id: 302,
            binCode: 'B3-02-C',
            quantity: 1,
            zone: 'Shelving B',
            parentZone: 'P&A Pick',
            locationType: 'pick',
          },
        ],
      ),
    ],
  },
  {
    shopifyOrderId: 9003,
    shopifyOrderName: '#TPC-9003',
    shopifyOrderGid: 'gid://shopify/Order/9003',
    createdAt: '2026-04-20T11:00:00Z',
    stagedAt: null,
    lifecycleStatus: 'picked',
    customer: { firstName: 'Priya', lastName: 'Patel', email: 'ppatel@example.com' },
    lines: [
      paa(
        'gid://shopify/LineItem/90031',
        'PAA-SHOES-42-WHT',
        'Shimano SH-RC502 Road Shoes — 42 / White',
        '012345678902',
        1.2,
        'SH-RC502-42-WHT',
        [
          {
            id: 303,
            binCode: 'E2-05-A',
            quantity: 1,
            zone: 'Shelving E',
            parentZone: 'P&A Pick',
            locationType: 'pick',
          },
        ],
      ),
      paa(
        'gid://shopify/LineItem/90032',
        'PAA-BKSHORTS-M-BLK',
        'Pearl Izumi Attack Bib Short — M / Black',
        '012345678903',
        0.4,
        null,
        [
          {
            id: 304,
            binCode: 'F1-01-A',
            quantity: 2,
            zone: 'Shelving F',
            parentZone: 'P&A Pick',
            locationType: 'pick',
          },
        ],
      ),
    ],
  },
  {
    shopifyOrderId: 9004,
    shopifyOrderName: '#TPC-9004',
    shopifyOrderGid: 'gid://shopify/Order/9004',
    createdAt: '2026-04-16T08:00:00Z',
    stagedAt: '2026-04-18T14:00:00Z',
    lifecycleStatus: 'lpu_staged',
    customer: { firstName: 'Marcus', lastName: 'Webb', email: 'mwebb@example.com' },
    lines: [
      bike(
        'gid://shopify/LineItem/90041',
        'BIK-TREK-DOMANE-SL6-56-WHT',
        'Trek Domane SL 6 — 56cm / White',
        '060115864001',
        21.0,
        'DOMANE-SL6-56-WHT-2023',
        [
          {
            id: 305,
            binCode: 'BIKE-A08',
            quantity: 1,
            zone: 'Bike Floor',
            parentZone: null,
            locationType: 'pick',
          },
        ],
      ),
    ],
  },
  {
    shopifyOrderId: 9005,
    shopifyOrderName: '#TPC-9005',
    shopifyOrderGid: 'gid://shopify/Order/9005',
    createdAt: '2026-04-09T09:00:00Z',
    stagedAt: '2026-04-11T10:00:00Z',
    lifecycleStatus: 'lpu_staged',
    customer: { firstName: 'Yvonne', lastName: 'Leung', email: 'yleung@example.com' },
    lines: [
      paa(
        'gid://shopify/LineItem/90051',
        'PAA-SADDLE-RACE',
        'Fizik Ares R3 Saddle — Black',
        '012345678911',
        0.45,
        'ARES-R3-BLK',
        [
          {
            id: 306,
            binCode: 'D4-08-A',
            quantity: 2,
            zone: 'Shelving D',
            parentZone: 'P&A Pick',
            locationType: 'pick',
          },
        ],
      ),
    ],
  },
  {
    shopifyOrderId: 9006,
    shopifyOrderName: '#TPC-9006',
    shopifyOrderGid: 'gid://shopify/Order/9006',
    createdAt: '2026-04-17T13:00:00Z',
    stagedAt: '2026-04-19T09:30:00Z',
    lifecycleStatus: 'lpu_staged',
    customer: { firstName: 'Derek', lastName: 'Stone', email: 'dstone@example.com' },
    lines: [
      paa(
        'gid://shopify/LineItem/90061',
        'PAA-JERSEY-M-BLU',
        'Rapha Core Jersey — M / Blue',
        '012345678909',
        0.35,
        null,
        [
          {
            id: 307,
            binCode: 'G3-04-A',
            quantity: 2,
            zone: 'Shelving G',
            parentZone: 'P&A Pick',
            locationType: 'pick',
          },
        ],
      ),
      paa(
        'gid://shopify/LineItem/90062',
        'PAA-BIBTIGHTS-M-BLK',
        'Rapha Pro Team Bib Tights — M / Black',
        '012345678910',
        0.5,
        null,
        [
          {
            id: 308,
            binCode: 'G3-05-B',
            quantity: 1,
            zone: 'Shelving G',
            parentZone: 'P&A Pick',
            locationType: 'pick',
          },
        ],
      ),
    ],
  },
];

export const LPU_SESSIONS: Record<number, LpuSession> = {
  // 9003: 1 of 2 items confirmed — deep link demo for mid-staging state
  9003: {
    orderId: 9003,
    lineStates: {
      'gid://shopify/LineItem/90031': {
        confirmed: true,
        exceptionType: null,
        exceptionReason: null,
      },
      'gid://shopify/LineItem/90032': {
        confirmed: false,
        exceptionType: null,
        exceptionReason: null,
      },
    },
  },
  // 9006: one item has exception (item_damaged)
  9006: {
    orderId: 9006,
    lineStates: {
      'gid://shopify/LineItem/90061': {
        confirmed: true,
        exceptionType: null,
        exceptionReason: null,
      },
      'gid://shopify/LineItem/90062': {
        confirmed: false,
        exceptionType: 'item_damaged',
        exceptionReason: 'Packaging torn during picking',
      },
    },
  },
};
